import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NgModel, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { ErrorStateMatcher, MatAutocompleteSelectedEvent, MatChipInputEvent } from '@angular/material';
import { Observable, of } from 'rxjs';
import { debounceTime, finalize, switchMap, tap } from 'rxjs/operators';
import { DataItem } from '../model/data.item';


@Component({
    selector: 'input-chips',
    templateUrl: './input.chips.html',
    styleUrls: ['./input.scss'],
    providers: [
        { 
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => InputChips),
          multi: true
        }
      ],
      // changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputChips implements OnInit, OnChanges {  //, ControlValueAccessor {

    @Input('multiple')
    multiple: boolean;

    @Input('values')
    values: DataItem[] = [];

    @Input('lookup')
    lookup: DataItem[] = [];

    filtered: DataItem[] = [];

    chipInputCtl = new FormControl();

    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    
    @ViewChild('chipInput', {static: true}) 
    chipInput: ElementRef;

    @Input('search-function')
    searchFunc: (string) => Observable<DataItem[]>;
    // onFilter: EventEmitter<any> = new EventEmitter<any>();
  
    isLoading: boolean;

    // private value: string;

    @Input('name')
    name: string;

    @Input('label')
    label: string;

    @Input('hint')
    hint: string;

    @Input('error-message')
    errorMessage: string;

    @Input('required')
    required: boolean;

    @Input('hidden')
    hidden: boolean;

    @Input('disabled')
    disabled: boolean;

    @Input('readonly')
    readonly: boolean;

    @Input('validator')
    validator: (string) => string; 

    error: string;

    // control: FormControl;

    constructor() {}

    ngOnInit() {
      // this.required = true;
      // this.control = new FormControl(this.value);

      // if (this.required) { this.control.setValidators([Validators.required]); }
      // if (this.disabled) { this.control.disable(); }

      if (this.searchFunc) {

          this.chipInputCtl.valueChanges
          .pipe(
              debounceTime(300),
              tap(() => { this.isLoading = null;} ),
              switchMap((name: string) => this.searchFunc(name)
              .pipe(
                  finalize(() => this.isLoading = false),
                  )
              )
          )
          .subscribe((result : DataItem[]) => { 
              // console.log(result); 
              this.filtered = result; 
          });
  
      }
      else if (this.filtered) {

          this.chipInputCtl.valueChanges
          .pipe(
              debounceTime(300),
              tap(() => { this.isLoading = null;} ),
              switchMap((name: string) => this.searchInner(name)
              .pipe(
                  finalize(() => this.isLoading = false),
                  )
              )
          )
          .subscribe((result : DataItem[]) => { 
              // console.log(result); 
              this.filtered = result; 
          });

          this.filtered = this.lookup.filter(() => true);

      }

      // this.chipInputCtl.valueChanges
      // .pipe(
      //     debounceTime(300),
      //     tap(() => { this.isLoading = null;} ),
      //     switchMap((name: string) => this.searchFunc(name)
      //     .pipe(
      //         finalize(() => this.isLoading = false),
      //         )
      //     )
      // )
      // .subscribe((result : {name: string, value: any}[]) => { 
      //     // console.log(result); 
      //     this.filtered = result; 
      // });
    
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    remove(array: any[], item: any): void {
      const index = array.indexOf(item);
  
      if (index >= 0) {
        array.splice(index, 1);
        return;
      }
  
      for(let i=0; i<array.length; i++) {
        if (array[i].id == item.id && array[i].guid == item.guid) {
          array.splice(i, 1);
          break;
        }
      }
    }
  
    selectedItem(event: MatAutocompleteSelectedEvent): void {
      // console.log(event);
      if (event && event.option) {
          let item = event.option.value;
          if (!this.values.includes(item)) {
            
            this.values.push(item);   //event.option.value);   // viewValue
          }
        }
  
      // this.toUserInput.nativeElement.value = '';
      this.chipInputCtl.setValue(null);
    }
    
    restart(event: MatChipInputEvent): void {
      const input = event.input;
    
      // Reset the input value
      if (input) {
        input.value = '';
      }
    }
    
    searchInner(phrase: string): Observable<DataItem[]> {
      if (!phrase || phrase.length == 0) {
          return of([]);
      }

      phrase = phrase.toLowerCase();

      let subset = this.lookup.filter((item) => item.name && item.name.toLowerCase().includes(phrase));
      return of(subset);
    }
  
    /*doFilter () {
      let chipStr = '';
          if (this.values) {
            chipStr = this.values[0].value;    //this.resources = {res: this.related}
          }
  
          // this.onFilter.emit(chipStr);
          // {
          //     year: this.year,
          //     month: this.month,
          //     startTime: this.startTime,
          //     endTime: this.endTime,
          //     tags: this.tags,
          //     res: resStr
          // })
    }*/

    readonly errorMatcher: ErrorStateMatcher = {
      isErrorState: (ctrl: FormControl) => {
          // (ctrl && ctrl.invalid)
          // this.error = null;
          // if (this.required && (!this.value || this.value.trim().length == 0)) {
          //     this.error = 'required';
          // }
          return !!this.error;
        }
    }

/*    changeValue(event: string) {
      this.value = event;
      this.propagateChange(event);

      if (this.validator) {
        this.error = this.validator(this.value);
        return;
      }

      this.error = null;
      if (this.required && (!event || event.trim().length == 0)) {
        this.error = 'Value is required';
      }
    }

    writeValue(value: any) {
      if (value !== undefined) {
        if (value != this.value) {
          this.changeValue(value);
        }
        this.value = value;
      }
    }

    propagateChange = (_: string) => {};

    registerOnChange(fn) {
      this.propagateChange = fn;
    }

    registerOnTouched() {} */
}